export interface Breed {
  key: string
  text: string
  priority: number,
  active: boolean,
  trot: boolean,
}

const breeds: Breed[] = [
  { key: 'SHA', text: 'Shagya', priority: 0, active: false, trot: false },
  { key: 'SI', text: 'Selle Italien', priority: 0, active: false, trot: false },
  { key: 'SWB', text: 'Cheval de sang Suedois', priority: 0, active: false, trot: false },
  { key: 'BA', text: 'Barbe', priority: 0, active: false, trot: false },
  { key: 'AB', text: 'Arabe-Barbe', priority: 0, active: false, trot: false },
  { key: 'OI', text: 'Origine Inconnue', priority: 0, active: false, trot: false },
  { key: 'AQPS', text: 'AQPS', priority: 6, active: true, trot: false },
  { key: 'AACR', text: 'ANGLO-ARABE DE CROISEMENT', priority: 0, active: false, trot: false },
  { key: 'OC', text: 'Origine constatee', priority: 0, active: true, trot: false },
  { key: 'HOLST', text: 'Holsteiner', priority: 0, active: true, trot: false },
  { key: 'DSA', text: 'DEMI SANG ARABE', priority: 0, active: true, trot: false },
  { key: 'KWPN', text: 'Koninklijke Warmbloed Paardenstamboek Nederland', priority: 0, active: false, trot: false },
  { key: 'OLD', text: 'Oldenbourg', priority: 0, active: false, trot: false },
  { key: 'HAN', text: 'Hanovrien', priority: 0, active: false, trot: false },
  { key: 'SBS', text: 'Cheval de sport belge', priority: 0, active: false, trot: false },
  { key: 'Z', text: 'ZANGERSHEIDE', priority: 0, active: false, trot: false },
  { key: 'SL', text: 'Cheval de Selle Luxembourgeois', priority: 0, active: false, trot: false },
  { key: 'BWP', text: 'Belgian warmblood', priority: 0, active: false, trot: false },
  { key: 'PFS', text: 'Poney francais de selle', priority: 0, active: false, trot: false },
  { key: 'PS', text: 'PUR-SANG', priority: 7, active: true, trot: false },
  { key: 'AC', text: 'ANGLO-ARABE DE COMPLEMENT', priority: 2, active: true, trot: false },
  { key: 'CS', text: 'CHEVAL DE SELLE', priority: 0, active: true, trot: false },
  { key: 'BYWBL', text: 'Bayerischts Warmblut', priority: 0, active: false, trot: false },
  { key: 'AR', text: 'ARABE', priority: 5, active: true, trot: false },
  { key: 'INCONNUE', text: 'INCONNUE', priority: 0, active: true, trot: false },
  { key: 'TF', text: 'Trotteur français', priority: 2, active: false, trot: true },
  { key: 'ONC', text: 'Origine non constatee', priority: 0, active: false, trot: false },
  { key: 'OE', text: 'Origine etrangere', priority: 0, active: true, trot: false },
  { key: 'AA', text: 'ANGLO-ARABE', priority: 3, active: true, trot: false },
  { key: 'TE', text: 'Trotteur étranger', priority: 1, active: false, trot: true },
  { key: 'SF', text: 'SELLE FRANCAIS', priority: 4, active: true, trot: false },
  { key: 'MECKL', text: 'Mecklenburg', priority: 0, active: false, trot: false },
  { key: 'DS', text: 'DEMI SANG', priority: 0, active: true, trot: false },
  { key: 'WESTF', text: 'Westfalen', priority: 0, active: false, trot: false },
  { key: 'SESF', text: 'SELLE ETRANGER (FACT.SF)', priority: 0, active: true, trot: false },
  { key: 'OS', text: 'Oldenburger Springpferd', priority: 0, active: false, trot: false },
  { key: 'RHEIN', text: 'Rheinland', priority: 0, active: false, trot: false },
]

const breedsObject = {} as Record<string, string>
breeds.forEach(breed => {
  breedsObject[breed.key] = breed.text
})

export function getBreedsLabel(key?: string): string | undefined {
  return key && breedsObject[key]
}

export const availableBreeds = breeds.filter(el => el.active).sort((op1, op2) => op2.priority - op1.priority || op1.text.localeCompare(op2.text))
export const availableTrotBreeds = breeds.filter(el => el.trot).sort((op1, op2) => op2.priority - op1.priority || op1.text.localeCompare(op2.text))
